import React, { useEffect, useState, useRef } from "react";
import classes from './AssetDepriciation.module.css';
import HeaderNav from '../../Components/Dahboard Header/HeaderNav/HeaderNav';
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from 'react-router-dom';
import { Eye, Pencil, Trash2, X, FileText, Calendar, DollarSign, TrendingDown } from 'lucide-react';
import searchicon from "../../Assets/searchicon.png";
import filter from "../../Assets/filter.png";
import axios from "axios";
import { BASE_URL } from "../../Components/API/Api";
import Swal from 'sweetalert2';

const AssetDepreciation = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const [isActive, setIsActive] = useState(false);
    const [selectedMetrics, setSelectedMetrics] = useState({
        total_depreciations: 0,
        total_amount: 0,
        avg_depreciation: 0,
    });

    const [loading, setLoading] = useState(true);
    const [modalLoading, setModalLoading] = useState(false);
    const [saveLoading, setSaveLoading] = useState(false);
    const [assetDepreciations, setAssetDepreciations] = useState([]);
    const [companyId, setCompanyId] = useState(null);

    // Modal state
    const [showCreateModal, setShowCreateModal] = useState(false);
    const [showViewEditModal, setShowViewEditModal] = useState(false);
    const [modalMode, setModalMode] = useState("view");
    const [selectedDepreciation, setSelectedDepreciation] = useState(null);

    // Create Modal state
    const [assets, setAssets] = useState([]);
    const [createFormData, setCreateFormData] = useState({
        asset_id: "",
        depreciation_date: "",
        depreciation_amount: "",
        accumulated_depreciation: "",
        net_book_value: "",
        journal_entry_id: "",
        company_id: ""
    });
    const [createLoading, setCreateLoading] = useState({
        assets: false
    });
    const [submitting, setSubmitting] = useState(false);

    // For searchable selects in create modal
    const [searchTerms, setSearchTerms] = useState({
        asset: ""
    });
    const [showDropdowns, setShowDropdowns] = useState({
        asset: false
    });
    
    // Create refs for each dropdown
    const assetRef = useRef(null);

    // Modal form data for view/edit
    const [modalData, setModalData] = useState({
        asset_name: "",
        asset_code: "",
        depreciation_date: "",
        depreciation_amount: "",
        accumulated_depreciation: "",
        net_book_value: "",
        journal_entry_id: "",
        company_id: ""
    });

    // Get company ID from localStorage - FIXED VERSION
    useEffect(() => {
        const getCompanyId = () => {
            console.log("Attempting to get company ID from various sources...");
            
            // First check if we have a company_id directly in localStorage (set by Login component)
            const directCompanyId = localStorage.getItem("company_id");
            if (directCompanyId) {
                console.log("Found company_id in localStorage:", directCompanyId);
                setCompanyId(directCompanyId);
                setCreateFormData(prev => ({
                    ...prev,
                    company_id: directCompanyId
                }));
                return;
            }
            
            // Check for companyInfo
            const companyInfo = localStorage.getItem("companyInfo");
            if (companyInfo) {
                try {
                    const parsed = JSON.parse(companyInfo);
                    console.log("Found companyInfo:", parsed);
                    
                    // Try to get ID from various possible fields
                    const id = parsed?.id || parsed?.company_id || parsed?.companyId;
                    if (id) {
                        setCompanyId(String(id));
                        setCreateFormData(prev => ({
                            ...prev,
                            company_id: String(id)
                        }));
                        console.log("Using company ID from companyInfo:", id);
                        return;
                    }
                } catch (error) {
                    console.error("Error parsing companyInfo:", error);
                }
            }
            
            // Check user data
            const userData = localStorage.getItem("user");
            if (userData) {
                try {
                    const parsed = JSON.parse(userData);
                    console.log("User data from localStorage:", parsed);
                    
                    // Check for direct company_id
                    if (parsed.company_id) {
                        setCompanyId(parsed.company_id);
                        setCreateFormData(prev => ({
                            ...prev,
                            company_id: parsed.company_id
                        }));
                        console.log("Using direct company_id from user:", parsed.company_id);
                        return;
                    }
                    
                    // Check for company object
                    if (parsed.company) {
                        const companyId = parsed.company?.id || parsed.company?.company_id || parsed.company?.companyId;
                        if (companyId) {
                            setCompanyId(String(companyId));
                            setCreateFormData(prev => ({
                                ...prev,
                                company_id: String(companyId)
                            }));
                            console.log("Using company ID from user.company:", companyId);
                            return;
                        }
                    }
                    
                    // Check for companies array
                    if (parsed.companies && Array.isArray(parsed.companies) && parsed.companies.length > 0) {
                        // Try to find main company
                        const mainCompany = parsed.companies.find(c => c.is_main === "1" || c.is_main === 1);
                        if (mainCompany) {
                            const companyId = mainCompany?.id || mainCompany?.company_id || mainCompany?.companyId;
                            if (companyId) {
                                setCompanyId(String(companyId));
                                setCreateFormData(prev => ({
                                    ...prev,
                                    company_id: String(companyId)
                                }));
                                console.log("Using main company ID from companies array:", companyId);
                                return;
                            }
                        }
                        
                        // Use first company
                        const firstCompany = parsed.companies[0];
                        if (firstCompany) {
                            const companyId = firstCompany?.id || firstCompany?.company_id || firstCompany?.companyId;
                            if (companyId) {
                                setCompanyId(String(companyId));
                                setCreateFormData(prev => ({
                                    ...prev,
                                    company_id: String(companyId)
                                }));
                                console.log("Using first company ID from companies array:", companyId);
                                return;
                            }
                        }
                    }
                } catch (error) {
                    console.error("Error parsing user data:", error);
                }
            }
            
            console.warn("No company ID found in any source");
        };
        
        getCompanyId();
    }, []);

    // Close dropdowns when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (assetRef.current && !assetRef.current.contains(event.target)) {
                setShowDropdowns(prev => ({ ...prev, asset: false }));
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    // Fetch data for create modal when opened
    useEffect(() => {
        if (showCreateModal) {
            if (companyId) {
                fetchAssets();
            } else {
                console.warn("Cannot fetch assets: Company ID not available");
                Swal.fire({
                    icon: 'warning',
                    title: 'Company ID Missing',
                    text: 'Please select a company and try again.',
                    confirmButtonText: 'Go to Dashboard'
                }).then(() => {
                    setShowCreateModal(false);
                    navigate('/dashboard');
                });
            }
        }
    }, [showCreateModal, companyId]);

    // Fetch asset depreciations when companyId is available
    useEffect(() => {
        if (companyId) {
            console.log("Company ID available, fetching asset depreciations for company:", companyId);
            fetchAssetDepreciations();
        } else {
            console.warn("Company ID not available yet, waiting...");
        }
    }, [companyId]);

    const fetchAssetDepreciations = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("authToken");
            
            if (!token) {
                console.error("No auth token found");
                Swal.fire({
                    icon: 'error',
                    title: 'Authentication Error',
                    text: 'Please log in again'
                });
                setLoading(false);
                return;
            }

            if (!companyId) {
                console.error("Company ID is required");
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Company ID not found. Please select a company and try again.'
                });
                setLoading(false);
                return;
            }

            console.log(`Fetching asset depreciations for company ID: ${companyId}`);
            
            const response = await axios.get(`${BASE_URL}/v1/assetdepreciation`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                params: {
                    company_id: companyId
                }
            });

            console.log("Asset depreciations response:", response.data);

            if (response.data.status && Array.isArray(response.data.data)) {
                setAssetDepreciations(response.data.data);
                
                // Update metrics
                const totalAmount = response.data.data.reduce((sum, dep) => sum + (parseFloat(dep.depreciation_amount) || 0), 0);
                const avgDepreciation = response.data.data.length > 0 ? totalAmount / response.data.data.length : 0;
                
                setSelectedMetrics({
                    total_depreciations: response.data.data.length,
                    total_amount: totalAmount,
                    avg_depreciation: avgDepreciation
                });
                
                console.log(`Loaded ${response.data.data.length} asset depreciations`);
            } else {
                console.warn("Unexpected response format:", response.data);
                setAssetDepreciations([]);
            }
        } catch (error) {
            console.error("Error fetching asset depreciations:", error);
            
            if (error.response) {
                console.error("Error response data:", error.response.data);
                console.error("Error response status:", error.response.status);
                
                let errorMessage = "Failed to fetch asset depreciations";
                if (error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                } else if (error.response.status === 401) {
                    errorMessage = "Unauthorized. Please log in again.";
                } else if (error.response.status === 404) {
                    errorMessage = "API endpoint not found";
                }
                
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: errorMessage
                });
            } else if (error.request) {
                console.error("No response received:", error.request);
                Swal.fire({
                    icon: 'error',
                    title: 'Network Error',
                    text: 'No response from server. Please check your connection.'
                });
            } else {
                console.error("Error setting up request:", error.message);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'An error occurred while setting up the request'
                });
            }
            
            setAssetDepreciations([]);
        } finally {
            setLoading(false);
        }
    };

    const fetchAssets = async () => {
        setCreateLoading(prev => ({ ...prev, assets: true }));
        try {
            const token = localStorage.getItem("authToken");
            
            if (!companyId) {
                console.error("Cannot fetch assets: No company ID");
                return;
            }
            
            const response = await axios.get(`${BASE_URL}/v1/fixedassets/fetch`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { company_id: companyId }
            });
            
            console.log("Assets response:", response.data);
            
            if (response.data.status && Array.isArray(response.data.data)) {
                // Filter assets that have positive net book value (still depreciating)
                const depreciableAssets = response.data.data.filter(asset => {
                    const netBookValue = parseFloat(asset.net_book_value) || 0;
                    return netBookValue > 0;
                });
                
                setAssets(depreciableAssets);
                console.log(`Loaded ${depreciableAssets.length} depreciable assets`);
            } else {
                console.warn("Unexpected assets response format:", response.data);
                setAssets([]);
            }
        } catch (error) {
            console.error("Error fetching assets:", error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'Failed to fetch assets. Please try again.'
            });
        } finally {
            setCreateLoading(prev => ({ ...prev, assets: false }));
        }
    };

    const pageMap = {
        '/dashboard': 'Dashboard',
        '/transactions': 'Transactions',
        '/accounts': 'Accounting',
        '/reports': 'Reports',
        '/banking': 'Banking',
        '/settings': 'Settings',
        '/fixed-assets': 'Fixed Assets',
    };

    // Process depreciation data for modal
    const processDepreciationData = (depreciation) => {
        console.log("Processing depreciation data:", depreciation);
        setModalData({
            id: depreciation.id,
            asset_name: depreciation.asset?.asset_name || depreciation.asset_name || "N/A",
            asset_code: depreciation.asset?.asset_code || depreciation.asset_code || "N/A",
            depreciation_date: depreciation.depreciation_date || "",
            depreciation_amount: depreciation.depreciation_amount || "",
            accumulated_depreciation: depreciation.accumulated_depreciation || "",
            net_book_value: depreciation.net_book_value || "",
            journal_entry_id: depreciation.journal_entry_id || "",
            company_id: depreciation.company_id || ""
        });
    };

    // Handle View/Edit icon clicks
    const handleViewClick = async (depreciation) => {
        setModalMode("view");
        setSelectedDepreciation(depreciation);
        setModalLoading(true);
        setShowViewEditModal(true);
        processDepreciationData(depreciation);
        setModalLoading(false);
    };

    const handleEditClick = async (depreciation) => {
        setModalMode("edit");
        setSelectedDepreciation(depreciation);
        setModalLoading(true);
        setShowViewEditModal(true);
        processDepreciationData(depreciation);
        setModalLoading(false);
    };

    // Handle modal input changes for view/edit
    const handleModalChange = (field, value) => {
        setModalData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    // Handle create form changes
    const handleCreateChange = (e) => {
        const { name, value } = e.target;
        setCreateFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // Handle searchable select for create modal
    const handleSearchChange = (field, e) => {
        setSearchTerms(prev => ({ ...prev, [field]: e.target.value }));
        if (!showDropdowns[field]) {
            setShowDropdowns(prev => ({ ...prev, [field]: true }));
        }
    };

    const handleSelect = (field, item) => {
        setCreateFormData(prev => ({
            ...prev,
            asset_id: item.id
        }));
        
        const displayName = `${item.asset_name} (${item.asset_code})`;
        setSearchTerms(prev => ({ ...prev, asset: displayName }));
        setShowDropdowns(prev => ({ ...prev, asset: false }));
    };

    const getSelectedName = (field) => {
        const id = createFormData.asset_id;
        if (!id) return "";
        
        const item = assets.find(i => i.id === id);
        if (!item) return "";
        
        return `${item.asset_name} (${item.asset_code})`;
    };

    const filterItems = (field) => {
        const searchTerm = (searchTerms.asset || "").toLowerCase();
        
        if (!Array.isArray(assets)) {
            return [];
        }
        
        return assets.filter(item => {
            if (!item) return false;
            
            const assetName = (item.asset_name || "").toLowerCase();
            const assetCode = (item.asset_code || "").toLowerCase();
            return assetName.includes(searchTerm) || assetCode.includes(searchTerm);
        });
    };

    const handleSave = async () => {
        if (modalMode === "edit") {
            setSaveLoading(true);
            try {
                const token = localStorage.getItem("authToken");

                // Double-check company ID
                let currentCompanyId = modalData.company_id || companyId;
                
                if (!currentCompanyId) {
                    currentCompanyId = localStorage.getItem("company_id");
                }

                if (!currentCompanyId) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Company ID Error',
                        text: 'Company ID not found. Please select a company and try again.'
                    });
                    setSaveLoading(false);
                    return;
                }

                // For edit mode, you might only allow updating certain fields
                const requestData = {
                    depreciation_date: modalData.depreciation_date,
                    depreciation_amount: modalData.depreciation_amount,
                    accumulated_depreciation: modalData.accumulated_depreciation,
                    net_book_value: modalData.net_book_value,
                    journal_entry_id: modalData.journal_entry_id || null,
                    company_id: currentCompanyId
                };

                console.log("Updating asset depreciation with data:", requestData);

                const response = await axios.post(
                    `${BASE_URL}/v1/assetdepreciation/update/${selectedDepreciation.id}`,
                    requestData,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        },
                    }
                );

                console.log("Update response:", response.data);

                if (response.data.status) {
                    fetchAssetDepreciations();
                    setShowViewEditModal(false);

                    Swal.fire({
                        icon: 'success',
                        title: 'Success!',
                        text: response.data.message || 'Asset depreciation updated successfully!',
                        timer: 3000,
                        showConfirmButton: false
                    });
                } else {
                    let errorMessage = "Failed to update asset depreciation";
                    if (response.data.message) {
                        if (typeof response.data.message === 'object') {
                            errorMessage = Object.values(response.data.message).flat().join(', ');
                        } else {
                            errorMessage = response.data.message;
                        }
                    }

                    Swal.fire({
                        icon: 'error',
                        title: 'Error!',
                        text: errorMessage
                    });
                }
            } catch (error) {
                console.error("Error updating asset depreciation:", error);

                let errorMessage = "Failed to update asset depreciation";

                if (error.response) {
                    if (error.response.data && error.response.data.message) {
                        if (typeof error.response.data.message === 'object') {
                            errorMessage = Object.values(error.response.data.message).flat().join(', ');
                        } else {
                            errorMessage = error.response.data.message;
                        }
                    } else if (error.response.status === 422) {
                        errorMessage = "Validation error. Please check all required fields.";
                    }
                } else if (error.request) {
                    errorMessage = "No response from server. Please check your connection.";
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            } finally {
                setSaveLoading(false);
            }
        } else {
            setShowViewEditModal(false);
        }
    };

    // Handle create submit
    const handleCreateSubmit = async (e) => {
        e.preventDefault();

        if (!createFormData.asset_id || 
            !createFormData.depreciation_date || 
            !createFormData.depreciation_amount ||
            !createFormData.accumulated_depreciation ||
            !createFormData.net_book_value) {
            Swal.fire("Error", "Please fill in all required fields", "error");
            return;
        }

        // Double-check company ID
        let currentCompanyId = companyId;
        
        if (!currentCompanyId) {
            currentCompanyId = localStorage.getItem("company_id");
            
            if (!currentCompanyId) {
                const companyInfo = localStorage.getItem("companyInfo");
                if (companyInfo) {
                    try {
                        const parsed = JSON.parse(companyInfo);
                        currentCompanyId = parsed?.id || parsed?.company_id || parsed?.companyId;
                    } catch (error) {
                        console.error("Error parsing companyInfo:", error);
                    }
                }
            }
            
            if (currentCompanyId) {
                setCompanyId(currentCompanyId);
            }
        }

        if (!currentCompanyId) {
            Swal.fire({
                icon: 'error',
                title: 'Company ID Error',
                text: 'Company ID not found. Please select a company and try again.',
                confirmButtonText: 'Go to Dashboard'
            }).then(() => {
                navigate('/dashboard');
            });
            return;
        }

        try {
            setSubmitting(true);
            const token = localStorage.getItem("authToken");

            const payload = {
                asset_id: createFormData.asset_id,
                depreciation_date: createFormData.depreciation_date,
                depreciation_amount: createFormData.depreciation_amount,
                accumulated_depreciation: createFormData.accumulated_depreciation,
                net_book_value: createFormData.net_book_value,
                journal_entry_id: createFormData.journal_entry_id || null,
                company_id: currentCompanyId
            };

            console.log("Creating asset depreciation with payload:", payload);

            const response = await axios.post(
                `${BASE_URL}/v1/assetdepreciation/create`,
                payload,
                { 
                    headers: { 
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    } 
                }
            );

            console.log("Create response:", response.data);

            if (response.data?.status) {
                Swal.fire({
                    title: "Success",
                    text: response.data.message || "Asset depreciation recorded successfully",
                    icon: "success",
                    timer: 1500,
                    showConfirmButton: false
                });
                
                resetCreateForm();
                onClose();
                refreshDepreciations();
            } else {
                Swal.fire("Error", response.data?.message || "Failed to record depreciation", "error");
            }
        } catch (error) {
            console.error("Error creating asset depreciation:", error);
            
            let errorMessage = "Something went wrong while recording depreciation";
            if (error.response?.data?.message) {
                if (typeof error.response.data.message === 'object') {
                    errorMessage = Object.values(error.response.data.message).flat().join(', ');
                } else {
                    errorMessage = error.response.data.message;
                }
            }
            
            Swal.fire("Error", errorMessage, "error");
        } finally {
            setSubmitting(false);
        }
    };

    // Handle delete depreciation with SweetAlert
    const handleDeleteClick = async (depreciation) => {
        const result = await Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel'
        });

        if (result.isConfirmed) {
            try {
                const token = localStorage.getItem("authToken");
                console.log(`Deleting asset depreciation with ID: ${depreciation.id}`);
                
                const response = await axios.delete(
                    `${BASE_URL}/v1/assetdepreciation/${depreciation.id}`,
                    {
                        headers: {
                            Authorization: `Bearer ${token}`,
                        },
                        params: {
                            company_id: companyId
                        }
                    }
                );

                console.log("Delete response:", response.data);

                if (response.data.status) {
                    fetchAssetDepreciations();

                    Swal.fire({
                        icon: 'success',
                        title: 'Deleted!',
                        text: response.data.message || 'Asset depreciation deleted successfully!',
                        timer: 3000,
                        showConfirmButton: false
                    });
                } else {
                    throw new Error(response.data.message || "Failed to delete asset depreciation");
                }
            } catch (error) {
                console.error("Error deleting asset depreciation:", error);

                let errorMessage = "Failed to delete asset depreciation";
                if (error.response && error.response.data && error.response.data.message) {
                    errorMessage = error.response.data.message;
                }

                Swal.fire({
                    icon: 'error',
                    title: 'Error!',
                    text: errorMessage,
                    confirmButtonText: 'OK'
                });
            }
        }
    };

    const resetCreateForm = () => {
        setCreateFormData({
            asset_id: "",
            depreciation_date: "",
            depreciation_amount: "",
            accumulated_depreciation: "",
            net_book_value: "",
            journal_entry_id: "",
            company_id: companyId
        });
        setSearchTerms({
            asset: ""
        });
    };

    const onClose = () => {
        setShowCreateModal(false);
        resetCreateForm();
        setShowDropdowns({
            asset: false
        });
    };

    const refreshDepreciations = () => {
        fetchAssetDepreciations();
    };

    // Format currency
    const formatCurrency = (value) => {
        if (!value) return "0.00";
        return parseFloat(value).toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    };

    // Format date
    const formatDate = (date) => {
        if (!date) return "—";
        return new Date(date).toLocaleDateString();
    };

    // Skeleton loader for table rows
    const TableSkeleton = () => {
        return Array.from({ length: 5 }).map((_, index) => (
            <tr key={index} className={classes.skeletonRow}>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td><div className={classes.skeletonText}></div></td>
                <td>
                    <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                        <div className={classes.skeletonIcon}></div>
                        <div className={classes.skeletonIcon}></div>
                        <div className={classes.skeletonIcon}></div>
                    </div>
                </td>
            </tr>
        ));
    };

    // Skeleton for modal form inputs
    const ModalInputSkeleton = () => (
        <div className={classes.skeletonInput}></div>
    );

    return (
        <div>
            <HeaderNav activePage={pageMap[location.pathname] || "Fixed Assets"} />

            <div className={classes.Container}>
                <div className={classes.Container}>
                      <div className={classes.actions}>
                        <button className={classes.btns} onClick={() => navigate('/transactions/sales-invoice/sale')}>
                            Sales Invoice
                        </button>
                        <button className={classes.btns} onClick={() => navigate('/Inventory/PurchaseOrder')}>
                            Purchase Order
                        </button>
                        <button className={`${classes.btns} ${isActive ? classes.active : ""}`} onClick={() => setIsActive(true)}>
                            Stock Delivery
                        </button>
                        <button onClick={() => navigate('/settings/product-services')} className={`${classes.btns} ${classes.greens}`}>
                            Product & Services
                        </button>
                    </div>

                    <header className={classes.Header}>
                        <h2 className={classes.Title}>Asset Depreciation</h2>
                    </header>

                    <div className={classes.entrjj}>
                        <div className={classes.allkads}>
                            <div className={classes.thrdkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Total Records</p>
                                    <p className={classes.kdptg1}>
                                        {selectedMetrics?.total_depreciations?.toLocaleString() ?? '0'}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Depreciation entries</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.frtkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Total Amount</p>
                                    <p className={classes.kdptg2}>
                                        {formatCurrency(selectedMetrics?.total_amount)}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Sum of depreciation</p>
                                    </div>
                                </div>
                            </div>
                            <div className={classes.fiftkad}>
                                <div className={classes.kad}>
                                    <p className={classes.kdptg}>Average</p>
                                    <p className={classes.kdptg3}>
                                        {formatCurrency(selectedMetrics?.avg_depreciation)}
                                    </p>
                                    <div className={classes.rvnue}>
                                        <p className={classes.skaltxt}>Per depreciation</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className={classes.headerActions}>
                        <div className={classes.actionsRight}>
                            <div className={classes.inputWrapper}>
                                <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
                                <input type="text" className={classes.searchBar} placeholder="Search depreciation" />
                            </div>
                            <div className={classes.selectWrapper}>
                                <select className={classes.dropdown}>
                                    <option value="">All Assets</option>
                                    {assets.map(asset => (
                                        <option key={asset.id} value={asset.id}>{asset.asset_name}</option>
                                    ))}
                                </select>
                                <span className={classes.dropdownArrow}>▼</span>
                            </div>
                            <div className={classes.inputWrapper}>
                                <input type="text" className={classes.searchBars} placeholder="Filter..." />
                                <img src={filter} alt="Filter" className={classes.inputIcon} />
                            </div>
                        </div>

                        <button className={classes.btnss} onClick={() => setShowCreateModal(true)}>
                            + Record Depreciation
                        </button>
                    </div>

                    <table className={classes.invoiceTable}>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Asset</th>
                                <th>Depreciation Date</th>
                                <th>Depreciation Amount</th>
                                <th>Accumulated Depreciation</th>
                                <th>Net Book Value</th>
                                <th>Journal Entry ID</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <TableSkeleton />
                            ) : assetDepreciations.length > 0 ? (
                                assetDepreciations.map((depreciation, index) => (
                                    <tr key={depreciation.id}>
                                        <td>{index + 1}</td>
                                        <td>
                                            {depreciation.fixedasset?.asset_name || "—"}
                                            {depreciation.asset?.asset_code && <div className={classes.smallText}>{depreciation.asset.asset_code}</div>}
                                        </td>
                                        <td>{formatDate(depreciation.depreciation_date)}</td>
                                        <td className={classes.amount}>{formatCurrency(depreciation.depreciation_amount)}</td>
                                        <td className={classes.amount}>{formatCurrency(depreciation.accumulated_depreciation)}</td>
                                        <td className={classes.amount}>{formatCurrency(depreciation.net_book_value)}</td>
                                        <td>{depreciation.journal_entry_id || "—"}</td>
                                        <td>
                                            <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                                                <Eye
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#007bff" }}
                                                    onClick={() => handleViewClick(depreciation)}
                                                />
                                                <Pencil
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#28a745" }}
                                                    onClick={() => handleEditClick(depreciation)}
                                                />
                                                <Trash2
                                                    size={16}
                                                    style={{ cursor: "pointer", color: "#dc3545" }}
                                                    onClick={() => handleDeleteClick(depreciation)}
                                                />
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                                        {loading ? "Loading..." : "No asset depreciation records found"}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* View/Edit Modal */}
            {showViewEditModal && (
                <div className={classes.overlay}>
                    <div className={classes.modal}>
                        <div className={classes.header}>
                            <div className={classes.title}>
                                <TrendingDown className={classes.icon} />
                                <h2>{modalMode === "edit" ? "Edit Depreciation Record" : "View Depreciation Record"}</h2>
                            </div>
                            <button className={classes.closeBtn} onClick={() => setShowViewEditModal(false)} disabled={saveLoading}>
                                <X size={18} />
                            </button>
                        </div>

                        <div className={classes.formGrid}>
                            {modalLoading ? (
                                Array.from({ length: 6 }).map((_, index) => (
                                    <div className={classes.formGroup} key={index}>
                                        <div className={classes.skeletonLabel}></div>
                                        <ModalInputSkeleton />
                                    </div>
                                ))
                            ) : (
                                <>
                                    <div className={classes.formGroup}>
                                        <label>Asset</label>
                                        <input
                                            type="text"
                                            value={`${modalData.asset_name} (${modalData.asset_code})`}
                                            readOnly
                                            className={classes.Field2}
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Depreciation Date</label>
                                        <input
                                            type={modalMode === "edit" ? "date" : "text"}
                                            value={modalData.depreciation_date}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("depreciation_date", e.target.value)}
                                            className={modalMode === "edit" ? classes.Field2 : classes.Field2}
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Depreciation Amount</label>
                                        <input
                                            type="number"
                                            value={modalData.depreciation_amount}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("depreciation_amount", e.target.value)}
                                            className={modalMode === "edit" ? classes.number2 : classes.Field2}
                                            min="0"
                                            step="0.01"
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Accumulated Depreciation</label>
                                        <input
                                            type="number"
                                            value={modalData.accumulated_depreciation}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("accumulated_depreciation", e.target.value)}
                                            className={modalMode === "edit" ? classes.number2 : classes.Field2}
                                            min="0"
                                            step="0.01"
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Net Book Value</label>
                                        <input
                                            type="number"
                                            value={modalData.net_book_value}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("net_book_value", e.target.value)}
                                            className={modalMode === "edit" ? classes.number2 : classes.Field2}
                                            min="0"
                                            step="0.01"
                                        />
                                    </div>

                                    <div className={classes.formGroup}>
                                        <label>Journal Entry ID</label>
                                        <input
                                            type="text"
                                            value={modalData.journal_entry_id}
                                            readOnly={modalMode === "view" || saveLoading}
                                            onChange={(e) => handleModalChange("journal_entry_id", e.target.value)}
                                            className={modalMode === "edit" ? classes.Field2 : classes.Field2}
                                            placeholder="Optional"
                                        />
                                    </div>

                                    <input type="hidden" value={modalData.company_id} />
                                </>
                            )}
                        </div>

                        <button
                            className={classes.saveBtn}
                            onClick={handleSave}
                            disabled={saveLoading}
                        >
                            {saveLoading ? (
                                <span className={classes.loadingText}>
                                    <span className={classes.spinner}></span>
                                    Saving...
                                </span>
                            ) : (
                                modalMode === "edit" ? "Update Record" : "Close"
                            )}
                        </button>
                    </div>
                </div>
            )}

            {/* Create Modal */}
            {showCreateModal && (
                <div className={classes.overlay}>
                    <div className={classes.modal}>
                        <div className={classes.header}>
                            <div className={classes.title}>
                                <DollarSign className={classes.icon} />
                                <h2>Record Asset Depreciation</h2>
                            </div>
                            <button className={classes.closeBtn} onClick={onClose}>
                                <X size={18} />
                            </button>
                        </div>

                        <form onSubmit={handleCreateSubmit}>
                            <div className={classes.formGrid}>
                                <div className={classes.formGroup}>
                                    <label>Select Asset *</label>
                                    <div className={classes.searchSelectWrapper} ref={assetRef}>
                                        <div className={classes.searchInputContainer}>
                                            <input
                                                type="text"
                                                className={classes.searchSelectInput}
                                                placeholder="Search and select asset..."
                                                value={showDropdowns.asset ? searchTerms.asset : getSelectedName('asset')}
                                                onChange={(e) => handleSearchChange('asset', e)}
                                                onClick={() => setShowDropdowns(prev => ({ ...prev, asset: true }))}
                                                onFocus={() => setShowDropdowns(prev => ({ ...prev, asset: true }))}
                                                required
                                            />
                                        </div>

                                        {showDropdowns.asset && (
                                            <div className={classes.searchDropdown}>
                                                <div className={classes.dropdownList}>
                                                    {createLoading.assets ? (
                                                        <div className={classes.dropdownItem}>Loading assets...</div>
                                                    ) : filterItems('asset').length === 0 ? (
                                                        <div className={classes.dropdownItem}>No depreciable assets found</div>
                                                    ) : (
                                                        filterItems('asset').map((item) => (
                                                            <div
                                                                key={item.id}
                                                                className={`${classes.dropdownItem} ${createFormData.asset_id === item.id ? classes.selectedItem : ''}`}
                                                                onClick={() => handleSelect('asset', item)}
                                                            >
                                                                {item.asset_name} ({item.asset_code}) - NBV: {formatCurrency(item.net_book_value)}
                                                            </div>
                                                        ))
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                    <small style={{ color: '#666', fontSize: '11px', marginTop: '4px', display: 'block' }}>
                                        Only assets with positive net book value are shown
                                    </small>
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Depreciation Date *</label>
                                    <input
                                        type="date"
                                        name="depreciation_date"
                                        value={createFormData.depreciation_date}
                                        onChange={handleCreateChange}
                                        required
                                    />
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Depreciation Amount *</label>
                                    <input
                                        type="number"
                                        name="depreciation_amount"
                                        placeholder="0.00"
                                        value={createFormData.depreciation_amount}
                                        onChange={handleCreateChange}
                                        min="0"
                                        step="0.01"
                                        required
                                    />
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Accumulated Depreciation *</label>
                                    <input
                                        type="number"
                                        name="accumulated_depreciation"
                                        placeholder="0.00"
                                        value={createFormData.accumulated_depreciation}
                                        onChange={handleCreateChange}
                                        min="0"
                                        step="0.01"
                                        required
                                    />
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Net Book Value *</label>
                                    <input
                                        type="number"
                                        name="net_book_value"
                                        placeholder="0.00"
                                        value={createFormData.net_book_value}
                                        onChange={handleCreateChange}
                                        min="0"
                                        step="0.01"
                                        required
                                    />
                                </div>

                                <div className={classes.formGroup}>
                                    <label>Journal Entry ID (Optional)</label>
                                    <input
                                        type="text"
                                        name="journal_entry_id"
                                        placeholder="Enter journal entry ID"
                                        value={createFormData.journal_entry_id}
                                        onChange={handleCreateChange}
                                    />
                                </div>
                            </div>

                            <button 
                                type="submit" 
                                className={classes.saveBtn} 
                                disabled={submitting}
                            >
                                {submitting ? "Recording..." : "Record Depreciation"}
                            </button>
                        </form>
                    </div>
                </div>
            )}

            <Footer />
        </div>
    );
};

export default AssetDepreciation;